import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Store } from '@ngxs/store';
import { get } from 'lodash';

import { TranslocoDirective } from '@jsverse/transloco';

@Component({
    selector: 'collapse-card',
    templateUrl: './collapse-card.component.html',
    styleUrls: ['./collapse-card.component.scss'],
    imports: [TranslocoDirective]
})
export class CollapseCardComponent implements OnInit {
  @Output() collapse = new EventEmitter();
  @Input() collapsed = false;
  tenantName: string;

  constructor(private readonly store: Store) {}

  ngOnInit() {
    this.store
      .select(_state => _state.configuration.configuration)
      .subscribe(_configuration => {
        this.tenantName = get(_configuration, 'tenantName', null);
      });
  }
}
